<div
    id="{{ betslip.betslipRealId }}"
    class="my-bets-list-betslip-container pinning-transition"
    *ngFor="let betslip of betslips; index as indx; first as isFirst; last as isLast; trackBy: betslipTrackBy"
    [ngClass]="{ 'my-bets-list-betslip-container-relative': !oneColumn }"
    [attr.data-betslip-pin-id]="betslip.betslipId">
    <div class="mybets-betslip-list-date" *ngIf="hasDateSeparators && betslip.showDate" [ngClass]="{ 'column-list-date': oneColumn }">
        {{ betslip.betPlacedDate | msMyBetsDateFormatter }}
    </div>
    <ms-my-bets-betslip [betslip]="betslip" [myBetsListContext]="myBetsListContext" [isLast]="isLast"> </ms-my-bets-betslip>
    <ms-share-my-bet-copy [betslipId]="betslip.betslipRealId" [location]="trackingLocation" [withHeader]="true"></ms-share-my-bet-copy>
</div>
